import {Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {FormgridLabelComponent} from '../../../../shared/formgrid-label/formgrid-label.component';
import {FormBuilder, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {Button} from 'primeng/button';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {VerifyMailComponent} from '../../../../backend/generic/verify-mail/verify-mail.component';
import {Password} from 'primeng/password';
import {environment} from '../../../../../../environments/environment';
import {InfoTextComponent} from '../../../../shared/common/info-text/info-text.component';
import {ViewService} from '../../../../shared/service/view.service';
import {PlayerProfileService} from '../../../service/player-profile.service';
import {RestErrorHelper} from '../../../../../helper/rest-error-helper';
import {RouterLink} from '@angular/router';
import {AuthenticateResponse} from '../../../model/auth/authenticate-response';
import {PLAYER_PREFIX_FULL} from '../../../player.routes';
import {LanguageDropdownComponent} from '../../../../shared/common/language-dropdown/language-dropdown.component';
import {SessionService} from '../../../../../services/session.service';
import {PlayerProfileServerSettings} from '../../../model/player-profile-server-settings';
import {InputText} from 'primeng/inputtext';
import {FrontendNotificationService} from '../../../../frontend/service/frontend-notification.service';
import {CountryDropdownComponent} from '../../../../shared/common/country-dropdown/country-dropdown.component';

@Component({
  selector: 'app-player-profile-register-form',
  imports: [
    ReactiveFormsModule,
    Button,
    TranslatePipe,
    VerifyMailComponent,
    Password,
    FormgridLabelComponent,
    InfoTextComponent,
    RouterLink,
    LanguageDropdownComponent,
    InputText,
    CountryDropdownComponent
  ],
  templateUrl: './player-profile-register-form.component.html',
  styleUrl: './player-profile-register-form.component.scss'
})
export class PlayerProfileRegisterFormComponent implements OnInit
{
  private formBuilder = inject(FormBuilder);
  public view = inject(ViewService);
  public playerProfileService = inject(PlayerProfileService);
  private restErrorHelper = inject(RestErrorHelper);
  private sessionService = inject(SessionService);
  private translate = inject(TranslateService);
  private frontendNotificationService = inject(FrontendNotificationService);

  @Input() settings: PlayerProfileServerSettings;
  @Output() onSuccess = new EventEmitter<boolean>();

  system = this.frontendNotificationService.system;
  form: UntypedFormGroup;
  passwordMinLength = environment.minPasswordLengthPlayer;
  isSaving: boolean;
  mailAddress: string;
  mailConfirmationCode: string;
  mailConfirmed: boolean;
  baseUrlMail = environment.baseUrlPlayerProfile;

  loginSuccess: boolean;
  authenticateResponse: AuthenticateResponse;
  playerProfileLink = PLAYER_PREFIX_FULL + '/profile';
  languageCd: string;
  countryCd: string;

  ngOnInit(): void
  {
    this.initForm();
    this.languageCd = this.sessionService.languageCode;
  }

  private initForm(): void
  {
    console.log('initForm()');

    this.form = this.formBuilder.group({
      mail: new UntypedFormControl('', [Validators.required]),
      firstname: new UntypedFormControl('', [Validators.required]),
      lastname: new UntypedFormControl('', [Validators.required]),
      password: new UntypedFormControl('', [Validators.required, Validators.minLength(this.passwordMinLength)]),
      passwordRetype: new UntypedFormControl('', [Validators.required, Validators.minLength(this.passwordMinLength)])
    });
  }

  public changeLanguage(): void
  {
    if (this.languageCd && this.sessionService.languageCode !== this.languageCd)
    {
      console.log('languageChanged() to: ' + this.languageCd);
      this.sessionService.languageCode = this.languageCd;
      this.translate.use(this.languageCd);
      // this.primeNG.setTranslation(new DateHelper().getCalendarLocale(languageCode));
      // window.location.reload();
    }
  }

  public trimField(field: string): void
  {
    const value = this.form.controls[field].value;
    if (value?.length > 0)
      this.form.controls[field].patchValue(value.trim());
  }

  public onOkClicked(): void
  {
    if (this.isSaving || this.form.invalid || !this.mailConfirmed || this.form.controls.password.value !== this.form.controls.passwordRetype.value || !this.countryCd)
      return;

    this.isSaving = true;
    this.form.disable();

    const body = {
      mail: this.form.controls.mail.value.trim(),
      firstname: this.form.controls.firstname.value,
      lastname: this.form.controls.lastname.value,
      mailConfirmationCode: this.mailConfirmationCode,
      password: this.form.controls.password.value,
      languageCd: this.languageCd,
      countryCd: this.countryCd
    };

    this.playerProfileService.registerNewPlayer(body).subscribe({
      next: (response: AuthenticateResponse) =>
      {
        this.isSaving = false;
        this.form.enable();
        this.authenticateResponseReceived(response);
      },
      error: error =>
      {
        this.isSaving = false;
        this.form.enable();
        this.restErrorHelper.handleErrorService(error);
      }
    });
  }

  private authenticateResponseReceived(response: AuthenticateResponse): void
  {
    if (response.errorMsg)
      this.restErrorHelper.showErrorMessageService(response.errorMsg, environment.toastDurationLong);
    else
    {
      console.log('Spieler erfolgreich angemeldet', response);

      this.authenticateResponse = response;
      this.loginSuccess = !!response;
      if (this.loginSuccess)
        this.onSuccess?.emit(true);
    }
  }
}
